module.exports = __webpack_public_path__ + "img/discard_silo.18f1391d.jpeg";